module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/index.js
// module id = 708
// module chunks = 0